export const customerSupportData = [
  {
    id: 1,
    image: "/images/logos/delivery1.svg",
    image_tag: "Get up to 50% off",
    title: "Track Order",
  },
  {
    id: 2,
    image: "/images/logos/pro2.svg",
    image_tag: "Get up to 50% off",
    title: "Pro Card",
  },
  {
    id: 3,
    image: "/images/logos/bulk.svg",
    image_tag: "Get up to 50% off",
    title: "Bulk Enquiry",
  },
  {
    id: 4,
    image: "/images/logos/store.svg",
    image_tag: "Get up to 50% off",
    title: "Store Nearby",
  },
];

export const categoryIcons: Record<string, string> = {
  "Vloerverwarming DS": "cbi:underfloor-heating",
  "WD-40": "formkit:tools",
  Deals: "mynaui:percentage-waves",
  "Schroeven & Bevestigingsmiddelen": "mdi:screw-round-top",
  "Elektrisch Gereedschap": "material-symbols:tools-power-drill-outline",
  Elektra: "icons8:electrical",
  "Gereedschap Accessoires": "carbon:tool-kit",
  Handgereedschap: "mingcute:screwdriver-line",
  "Hang- & Sluitwerk": "tabler:lock-filled",
  "Kranen & Douches": "cil:shower",
  IJzerwaren: "material-symbols:hardware-outline-sharp",
  Installatie: "codicon:tools",
  "Lijmen, Kitten & Tapes": "la:tape",
  Tuingereedschap: "tabler:shovel",
  "Verf & Accessoires": "octicon:tools-24",
  Verlichting: "tdesign:lighting-circle",
  "Verwarming & Ventilatie": "iconoir:heating-square",
  "Werkkleding & PBM": "healthicons:ppe-suit-outline",
  Werkplaats: "pajamas:work",
  "Reinigen & Onderhoud": "healthicons:cleaning-outline",
  Uitverkoop: "foundation:burst-sale",
};
